import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import MessageBox from './MessageBox';

import store from "src/store";

export default function CustomToaster(props) {
    const useStyles = makeStyles({
        root: {
            transform: 'translate(-50%, -50%)',
            position: 'fixed',
            zIndex: 1,
            top: '85px',
            left: '50%',
            width: '600px'
        },
        message: {
            width: '100%'
        },
        info: {
            color: "#799fd4"
        },
        closeLink: {
            color: "#799fd4",
            cursor: 'pointer'
        }
    });

    const classes = useStyles();

    const onClose = () => {
        store.hideToaster();
    }

    store.useRerenderIfChange(()=>[
        store.toaster
    ]);

    return(
        <>
        {
            store.toaster.open ? 
            <Box>  
                <MessageBox variant={store.toaster.variant} className={classes.root}>
                    <Typography component="span" variant="body2" className={`${classes[store.toaster.variant]} ${classes.message}`}>
                        {store.toaster.message}
                    </Typography>

                    <div className={classes.closeLink} onClick={() => onClose()}>Dismiss</div>

                </MessageBox>
            </Box> : null
        }
        </>
    )
}